<template>
  <el-submenu
    v-if="hasPermission('feature_group:devices')"
    class="side-navigator__submenu"
    index="devices">
    <template slot="title">
      Devices
    </template>
    <el-menu-item
      v-if="hasPermission('feature:devices:devices')"
      class="side-navigator__menu-item"
      index="/devices">
      Devices
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:devices:issues')"
      class="side-navigator__menu-item"
      index="/device-issues">
      Issues
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:devices:callQueue')"
      class="side-navigator__menu-item"
      index="/issue-queue">
      Issue Queue
    </el-menu-item>
  </el-submenu>
</template>

<script>
import NavigationIcon from './NavigationIcon'

export default {
  name: 'DevicesNavigationGroup',
  components: {
    NavigationIcon,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/DevicesNavigationGroup.vue